import React, { useRef, useEffect, useState } from "react";
import useCustomFormValidation from "../hooks/ErrorHandling/useCustomFormValidation";
import { RESET_PASS_URL } from "../utils/constants";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { VALID_TOKEN_URL } from "../utils/constants";
import FooterFixed from "./FooterFixed";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { showLoader, hideLoader } from "../utils/loaderSlice"; // Ensure the path is correct
import { sign } from "react-advanced-cropper";
import { ReactComponent as LeftSideArrowIcon } from "../assets/images/icons/LeftSideArrowIcon.svg";
import ZinancialLogo from "../assets/images/ZinancialLogo.webp";
import Footer from "./Footer";

const validationRules = {
  new_password: {
    required: true,
    errorMessage: "Cannot be left blank",
  },
  password_confirmation: {
    required: true,
    errorMessage: "Cannot be left blank",
  },
};

const ResetPassword = () => {
  const Navigate = useNavigate();
  const dispatch = useDispatch();
  const [error, setErrors] = useState(false);
  const [nperror, setNperrors] = useState(false);
  const [succesmsg, setSuccErrors] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");

  const location = useLocation();
  const password_confirmd = useRef(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const [matchPassword, setMatchPassword] = useState(false);
  const { token, email } = useParams();
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConPassword, setShowConPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    new_password: "",
    password_confirmation: "",
  });

  const signupData = location.state?.signupData;
  const sessionToken = location.state?.sessionToken;
  const authType = location.state?.authType;

  const { values, errors, touched, handleChange, handleBlur, validateField, isFormValid, isFetching } =
    useCustomFormValidation(formData, validationRules);

  const handleInputChange = (event) => {
    handleChange(event);
    const { name, value } = event.target;
    if (name === "password_confirmation") {
      confirmPasswordMatch(value);
    }
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const confirmPasswordMatch = (value) => {
    if (formData.new_password !== value) {
      setMatchPassword(formData.new_password !== value);
    } else {
      setMatchPassword("");
      //setIsButtonDisabled(false);
    }
  };

  const handleButtomClick = async (event) => {
    event.preventDefault();

    const formValid = isFormValid();
    if (formValid === true && formData !== "") {
      delete formData.password_confirmation;
      try {
        const response = await fetch(RESET_PASS_URL, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ ...formData, session_token: sessionToken, email: signupData.email }),
        });
        const data = await response.json();
        if (data.status == "error") {
          setErrors(data.message);
        }
        if (data?.success || data?.data.success) {
          setSuccErrors(data.message);
          const timer = setTimeout(() => {
            Navigate("/", { state: { signupData, authType } });
          }, 1000);
          return () => clearTimeout(timer);
        }
        if (data.message) {
          setNperrors(data.message);
        }
        //console.warn(data,"data here now")
      } catch (error) {
        console.error("Error:", error);
        setErrorMessage("An error occurred. Please try again.");
      }
    }
  };
  const toggleNewPasswordVisibility = () => {
    setShowNewPassword(!showNewPassword);
  };
  const toggleConPasswordVisibility = () => {
    setShowConPassword(!showConPassword);
  };

  useEffect(() => {
    if (isFetching) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
  }, [isFetching]);

  return (
    <div className="bg-white h-screen flex flex-col">
      <Link to="/" className="w-40 p-4 cursor-pointer ">
        <img src={ZinancialLogo} alt="Zinancial Logo" />
      </Link>
      <Link to="/" className="w-40 px-4 cursor-pointer ">
        <button className="flex  bg-F4F4F4 border border-EAE2E2 rounded-lg py-2  px-5 gap-4 items-center">
          <LeftSideArrowIcon />
          <span className="text-[#535252] text-lg font-medium">BACK</span>
        </button>
      </Link>
      <div className="flex items-center justify-center grow min-h-0">
        <div className="px-5 py-14 border-[#EDEDED] border rounded mx-28 w-[32rem] max-w-xl stroke-[#EDEDED]  stroke-1 shadow">
          <div className="text-1D5D9B text-24 font-bold  px-4 text-center">Reset Password</div>
          <div className="flex flex-col ">
            <form onSubmit={(e) => e.preventDefault()} className="flex flex-col py-2 px-5" id="ResetPassForm">
              <label htmlFor="password" className="text-545B61 text-14 font-500">
                New Password
              </label>
              <div className="flex justify-between items-center w-full relative">
                <input
                  className="border border-E4EDF3 rounded-md focus:outline-none focus:border-sky-700 w-full px-1"
                  id="password"
                  name="new_password"
                  type={showNewPassword ? "text" : "password"}
                  placeholder=""
                  onChange={handleInputChange}
                />
                <span
                  className="absolute inset-y-0 right-3 flex items-center cursor-pointer text-gray-600 "
                  onClick={toggleNewPasswordVisibility}
                >
                  <i className={`bi ${showNewPassword ? "bi-eye" : "bi-eye-slash"}`} />
                </span>
              </div>
              <div className="h-6">
                {errors.new_password && !formData.new_password && (
                  <span className="text-red-500 font-normal text-12">{errors.new_password}</span>
                )}
              </div>
              <label htmlFor="password_confirmation" className="text-545B61 text-14 font-500">
                Confirm Password
              </label>
              <div className="flex justify-between items-center w-full relative">
                <input
                  className="border border-E4EDF3 rounded-md focus:outline-none focus:border-sky-700 w-full px-1"
                  name="password_confirmation"
                  id="password_confirmation"
                  type={showConPassword ? "text" : "password"}
                  placeholder=""
                  onChange={handleInputChange}
                />
                <span
                  className="absolute inset-y-0 right-3 flex items-center cursor-pointer text-gray-600 "
                  onClick={toggleConPasswordVisibility}
                >
                  <i className={`bi ${showConPassword ? "bi-eye" : "bi-eye-slash"}`} />
                </span>
              </div>
              <div className="h-6">
                {errors.password_confirmation && !formData.password_confirmation ? (
                  <span className="text-red-500 font-normal text-12">{errors.password_confirmation}</span>
                ) : matchPassword ? (
                  <span className="text-red-500 font-normal text-12">Passwords do not match.</span>
                ) : null}
              </div>
              <button
                onClick={handleButtomClick}
                type="submit"
                className={`bg-sky-700 w-full text-white font-bold py-1 rounded-md mb-3  hover:bg-sky-600 ${Boolean(matchPassword || !formData.password_confirmation || !formData.new_password) ? "opacity-50 cursor-not-allowed" : ""}`}
                disabled={Boolean(matchPassword || !formData.password_confirmation || !formData.new_password)}
              >
                Submit
              </button>
              <div className="h-6">
                {succesmsg && <span className="mt-1 text-red-500 font-normal text-xs">{succesmsg}</span>}
                {nperror && <span className="text-red-500 font-normal text-xs">{nperror}</span>}
              </div>
            </form>
            <div className="flex items-center">
              <hr className="h-[1px] w-full bg-[#EDEDED]" />
            </div>
            <div className="flex items-center justify-between text-base px-5 pt-4">
              <a href="/" className="font-bold text-F16136">
                Login
              </a>
              <a href="/signup" className="font-bold text-F16136">
                Sign Up
              </a>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default ResetPassword;
